import { Navigate } from "react-router-dom";
import { hasCompletedRegimeSelection } from "./tdsStorage";
import { TDS_START_PATH, TDS_WORKSPACE_PATH } from "./tdsNavConfig";

export default function TdsIndexRedirect() {
  if (hasCompletedRegimeSelection()) {
    return <Navigate to={TDS_WORKSPACE_PATH} replace />;
  }
  return <Navigate to={TDS_START_PATH} replace />;
}
